import React from 'react';

import type { AccessRules } from '../access/accessAdapter';
import { meetsAdminLevel, meetsOrganizerLevel } from '../access/accessAdapter';
import type { AdminLevel, OrganizerLevel } from '../access/accessLevels';

interface AccessBoundaryProps {
    access: AccessRules;
    requireAdmin?: AdminLevel | undefined;
    requireOrganizer?: OrganizerLevel | undefined;
    allow?: boolean | undefined;
    fallback?: React.ReactNode;
    children: React.ReactNode;
}

const AccessBoundary: React.FC<AccessBoundaryProps> = ({
    access,
    requireAdmin,
    requireOrganizer,
    allow = true,
    fallback = null,
    children,
}) => {
    const adminAllowed = requireAdmin
        ? access.adminLevel
            ? meetsAdminLevel(access.adminLevel, requireAdmin)
            : false
        : true;

    const organizerAllowed = requireOrganizer
        ? access.organizerLevel
            ? meetsOrganizerLevel(access.organizerLevel, requireOrganizer)
            : false
        : true;

    if (allow && adminAllowed && organizerAllowed) {
        return <>{children}</>;
    }

    return <>{fallback}</>;
};

export default AccessBoundary;
